import React from "react";
import { BeatLoader } from "react-spinners";
import { PRIMARY_COLOR } from "../constant";

export default function Loader({
    loading,
    className,
    color = PRIMARY_COLOR,
    size,
}) {
    return (
        <div
            className={`min-h-[80px] flex justify-center items-center ${className}`}
        >
            <BeatLoader loading={loading} color={color} size={size} />
        </div>
    );
}
